<svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 12C0 5.37258 5.37258 0 12 0H64C70.6274 0 76 5.37258 76 12V64C76 70.6274 70.6274 76 64 76H12C5.37258 76 0 70.6274 0 64V12Z" fill="white" fill-opacity="0.05"/>
<circle cx="29" cy="38" r="3" fill="white" fill-opacity="0.7"/>
<circle cx="38" cy="38" r="3" fill="white" fill-opacity="0.7"/>
<circle cx="47" cy="38" r="3" fill="white" fill-opacity="0.7"/>
</svg>
